import React, { Fragment, useState } from "react";
import Loader from "../loader/loader";
import { DownloadIcon } from "../../../assets/icons";

interface IFilePreviewProps {
  title?: string;
  url?: string;
}

export const FilePreview = (props: IFilePreviewProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <>
      {loading && <Loader />}
      <div className="flex flex-col text-gray-900 block px-4 py-4 text-sm shadow border-b border-gray-200 rounded-b-lg h-full">
        <div className="relative flex">
          <div className="w-full mt-4 mb-4 flex justify-between">
            {props?.title}
            {props?.url && (
              <div className="flex relative cursor-pointer rounded-lg font-medium">
                <DownloadIcon className="w-4 text-gray-500 group-hover:text-blue-500 mr-1"></DownloadIcon>

                <span className="text-blue-700 group-hover:text-blue-500">
                  <a href={props?.url} target={"_blank"} rel="noreferrer">
                    Open
                  </a>
                </span>
              </div>
            )}
          </div>
        </div>
        {props?.url && (
          <iframe
            src={props?.url}
            title={props?.title}
            style={{ width: "100%", height: "100%" }}
            onLoad={() => setLoading(false)}
          ></iframe>
        )}
      </div>
    </>
  );
};
